import React from 'react';
import s from './styles.module.scss';
import Button from '../button';
import { ReactComponent as ErrorIcon } from '../../assets/error.svg';
import { ReactComponent as InfoIcon } from '../../assets/info.svg';
import { ReactComponent as CheckmarkIcon } from '../../assets/Checkmark_in_circle.svg';

const Modal = ({
    isOpen,
    onClose,
    title,
    message,
    type = 'info', // 'info', 'success', 'error'
    primaryButtonText = 'OK',
    secondaryButtonText = null,
    onPrimaryClick = onClose,
    onSecondaryClick = onClose,
    showIcon = true
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return (
          <div className={s.modalIcon}>
            <CheckmarkIcon width="48" height="48"/>
          </div>
        );
      case 'error':
        return (
          <div className={`${s.modalIcon} ${s.error}`}>
            <ErrorIcon width={48} height={48} />
          </div>
        );
      default:
        return (
          <div className={`${s.modalIcon} ${s.info}`}>
            <InfoIcon width={48} height={48} />
          </div>
        );
    }
  };

  return (
    <div className={s.modalBackdrop} onClick={handleBackdropClick}>
      <div className={s.modalContainer}>
        <div className={s.modalContent}>
          {showIcon && getIcon()}

          <div className={s.modalText}>
            <h3 className={s.modalTitle}>{title}</h3>
            <p className={s.modalMessage}>{message}</p>
          </div>

          <div className={s.modalActions}>
            {secondaryButtonText && (
              <Button
                variant="secondary"
                size="large"
                onClick={onSecondaryClick}
                className={s.modalSecondaryButton}
              >
                {secondaryButtonText}
              </Button>
            )}
            <Button
              variant="primary"
              size="large"
              onClick={onPrimaryClick}
              className={s.modalPrimaryButton}
            >
              {primaryButtonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal; 